import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransformTimePipe } from './pipe.time';

/**
 * The TransformDuration module
 *
 * import { TransformTimeModule } from 'styleguide/src/shared/pipe/time/pipe.time.module';
 */
@NgModule({
    declarations: [
        TransformTimePipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TransformTimePipe
    ]
})

export class TransformTimeModule {}
